<template>
  <div
    class="h-full grid gap-x-3 overflow-hidden bg-gray-100 rounded-lg p-2.5"
    style="grid-template-columns: 1fr 300px"
  >
    <div
      class="grid gap-y-3 overflow-hidden"
      style="grid-template-rows: 180px 1fr"
    >
      <div class="bg-white rounded-lg p-2.5 grid grid-rows-2">
        <div class="grid grid-cols-2 border-b border-gray-100">
          <div
            class="border-r flex flex-col gap-y-3 justify-center px-5 pb-2.5 border-gray-100"
          >
            <c_titles value1="总应收" value2="欠款" />
            <div class="flex items-end">
              <c_money
                :key="state.meeting?.collected_statistic?.receivable_amount"
                :value="state.meeting?.collected_statistic?.receivable_amount"
                bold
                :size="18"
                color="#080"
              />
              <text
                class="text-gray-400"
                style="font-size: 12px; line-height: 12px"
              >
                {{
                  "/" +
                  $priceFormat(state.meeting?.collected_statistic?.uncollected_amount)
                }}
              </text>
            </div>
          </div>
          <div
            class="border-r flex flex-col gap-y-3 justify-center px-5 pb-2.5 border-gray-100"
          >
            <c_titles value1="采购金额合计" value2="未付" />
            <div class="flex items-end">
              <c_money
                :key="state.meeting?.purchase_statistic?.purchase_amount"
                :value="state.meeting?.purchase_statistic?.purchase_amount"
                bold
                :size="18"
                color="#1e90ff"
              />
              <text
                class="text-gray-400"
                style="font-size: 12px; line-height: 12px"
              >
                {{
                  "/" +
                  $priceFormat(state.meeting?.purchase_statistic?.unpaid_purchase_amount)
                }}
              </text>
            </div>
          </div>
        </div>
        <div class="huiyi-detail-more-box-t">
          <div>
            <li>物料筹备</li>
            <li>{{ state.meeting?.material_statistic?.count }}</li>
          </div>
          <div>
            <li>报名人数</li>
            <li>{{ state.meeting?.signup_statistic?.count }}</li>
          </div>
          <div>
            <li>参会人数</li>
            <li>{{ state.meeting?.meeting_attendee_statistic?.count }}</li>
          </div>
          <div>
            <li>需接机</li>
            <li>{{ state.meeting?.meeting_attendee_statistic?.need_reception_count }}</li>
          </div>
          <div>
            <li>需住宿</li>
            <li>{{ state.meeting?.meeting_attendee_statistic?.need_room_arrangement_count }}</li>
          </div>
          <div>
            <li>签到场次</li>
            <li>{{ state.meeting?.meeting_schedule_statistic?.need_signup_count }}</li>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-lg p-2.5 flex flex-col overflow-hidden">
        <ul class="border-b border-gray-100 font-bold text-sm pb-2.5">
          会议日志
        </ul>
        <div class="flex-1 overflow-y-auto mt-2.5">
          <div
            class="border-b border-gray-100 px-2.5 pb-2.5 mb-2.5 flex flex-col gap-y-2"
            v-for="item in state.meetingLog"
            :key="item"
          >
            <ul class="flex items-center gap-x-5">
              <strong>{{ item.create_time }}</strong>
              <c_status showBg arrName="HuiYi_CaoZuo_Type" :value="1" />
            </ul>
            <div v-html="item.content"></div>
            <c_cell title="附件">
              <template #default>
                <div
                  class="flex flex-wrap gap-x-3 gap-y-2"
                  v-if="item.attachment?.length > 0"
                >
                  <li
                    v-for="file in item.attachment"
                    class="hover:underline cursor-pointer text-green-700"
                    @click="$openFile(file.file_url)"
                  >
                    {{ file.filename }}
                  </li>
                </div>
                <text v-else>-</text>
              </template>
            </c_cell>
            <div class="flex items-center text-gray-400 text-xs gap-x-2 mt-2">
              <text class="text-sm text-gray-600">
                {{ item?.add_admin_name }}
              </text>
              <text>{{ item?.add_department_name }}</text>
              <text class="ml-1">{{ item?.create_time }} 创建</text>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-lg p-2.5 flex flex-col overflow-hidden">
      <ul class="font-bold text-sm pb-2.5">
        会议日程
      </ul>
      <div
        v-if="state.meetingSchedule?.length > 0"
        class="overflow-y-auto py-7 px-2.5 rounded-lg"
        style="background: linear-gradient(to bottom, #e9f4fe, #fff, #eefbf8)"
      >
        <div
          v-for="(item, index) in state.meetingSchedule"
          :key="item"
          class="mb-5"
        >
          <ul class="flex items-center gap-x-2 text-sm">
            <div class="c-icon-trigon-r" style="--size: 10"></div>
            <strong style="color: #414a96">
              {{ "DAY" + (index + 1).toString().padStart(2, "0") }}
            </strong>
            <text class="font-bold">{{ item.date }}</text>
          </ul>
          <div class="text-xs my-3 font-bold">
            {{ item.meetingPlace?.name }}
          </div>
          <div
            style="grid-template-columns: 0.7fr 1fr"
            class="p-2 grid text-xs rounded bg-blue-100 items-center"
          >
            <li style="min-width: 0">
              {{
                $dayjs(item.start_time, "HH:mm:ss").format("HH:mm") +
                " ~ " +
                $dayjs(item.end_time, "HH:mm:ss").format("HH:mm")
              }}
            </li>
            <div class="flex gap-x-1 items-center">
              <text style="color: #063f94">●</text>
              <li
                class="text-xs font-bold cursor-pointer"
                style="color: #063f94"
              >
                {{ item.name }}
              </li>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" v-else style="max-height: 70%">
        <el-image
          :src="require('@/assets/images/nodata.png')"
          style="width: 80%"
        />
        <el-button link type="primary" :icon="Plus" @click="toRiCheng">
          去添加
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meeting_info } from "@/http/meeting";
export default {
  props: { meeting_id: Number },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      meeting_info(props.meeting_id).then((res) => {
        if (res.status == 200) {
          const { meeting, meetingLog, meetingSchedule, meetingAccounting } =
            res.data.data || {};
          state.meeting = meeting;
          state.meetingLog = meetingLog;
          state.meetingSchedule = meetingSchedule;
          state.meetingAccounting = meetingAccounting;
        }
      });
    };

    //跳转到日程
    const toRiCheng = () => {
      emit("toRiCheng");
    };
    return { state, props, toRiCheng };
  },
};
</script>

<style lang="scss" scoped>
.huiyi-detail-more-box-t {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  padding-top: 10px;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 10px;

    & > li:first-child {
      color: #a2a2a2;
      font-size: 80%;
    }

    & > li:last-child {
      font-weight: 600;
    }
  }
}
</style>
